/**
 * Payment types (`bank`, `mollie`) the buyer may choose for a country, mirroring
 * php-core CountryPaymentMethods. php-core validates the order again, this only
 * decides which tiles the checkout shows.
 *
 * Returns null when no rule applies (feature off, or the country's group is
 * unrestricted) and [] while the rules are active but no country is chosen yet.
 */
export function allowedPaymentTypes(rules, country) {
    if (!rules || !rules.groups) {
        return null;
    }
    let code = String(country || '').trim().toUpperCase();
    if (!code) {
        return [];
    }
    if (code === 'UK') {
        code = 'GB';
    }
    const group = (rules.sepa_countries || []).includes(code) ? 'sepa' : 'non_sepa';

    return rules.groups[group] ?? null;
}
